export default "__VITE_ASSET__CRTDI9Oj__"